import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-user-task',
  templateUrl: './user-task.component.html',
  styleUrls: ['./user-task.component.css']
})
export class UserTaskComponent implements OnInit {

  usersList: any= []
  status = ""
  userId = ""
  date1:any
  date2: any
  filteredData: any= []
  visible = false

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getUsersWithoutCustomers()
    // this.date2 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
    // console.log(new Date(this.date2).getTime())
    // this.date1 = new Date()
    // this.date1.setDate(this.date1.getDate()-30);
    // this.date1 = formatDate(this.date1, 'yyyy-MM-dd', 'en-US')
    // console.log(this.date1)

  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    console.log(event);
    let pageNumber = 0
    if(this.pageNumber == 0){
      pageNumber = this.pageNumber
    }else{
      pageNumber = this.pageNumber-1
    }
    this.getFilteredData(pageNumber,this.totalRecords)

  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
      }
    )
  }

  getFilteredData(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    let dateTo = new Date(this.date1).getTime()
    let dateFrom = new Date(this.date2).getTime()

    this.generic_service.taskFilterByAndUserIdAndDates(pageNumber,recordsPerPage,this.userId,dateTo,dateFrom).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.filteredData = response.response.taskList
        this.totalRecords = response.response.totalRecords
        this.visible = true
        this.isLoading = false

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

}